module.exports = __webpack_public_path__ + "static/media/Environment.54894093.png";